module.exports = __webpack_public_path__ + "img/envelope-16.72f4aed9.svg";